import { useParams } from "react-router-dom";
import Footer from "../organisms/Footer/Footer";
import { useEffect, useState } from "react";
import { fetchBlogs } from "../../app/helper/functions";
import type { Blog } from "../../app/utlis/type";
import LoadingScreen from "../atoms/LoadingScreen/LoadingScreen";

const BlogDetailsPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState<Blog | null>(null);

  useEffect(() => {
    try {
      setLoading(true);
      fetchBlogs().then((res) => {
        console.log(res)
      setBlogs(res.filter((data) => data.id === id)[0]);
      });
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    loading ? <LoadingScreen /> :<div className="bg-darkGreyTernary">
      <div className="w-full pt-16 md:pt-0 bg-black text-white">
        <img className="w-full aspect-[2/1] object-cover" src={blogs?.imageUrl} alt="" />
      </div>
      <div className="blog-details p-5 md:p-10 lg:px-20 text-[#f0f0f0]" dangerouslySetInnerHTML={{__html: (blogs?.description) || ''}}>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetailsPage;
